import { BannerInformation, BannerInformationPropsType } from 'components/bannerInformation';
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import {
  selectEsitiByTicket,
  selectIsCustomMobileOpened,
  selectIsFullCart,
  selectIsLoadingVendita,
} from '../carrelloSelectors';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';

import CarrelloBonusButtons from '../carrelloBonusButtons/CarrelloBonusButtons';
import { CustomMobileInput } from 'components/customMobileInput';
import { MovimentiTipoScommessaEnum } from 'types/swagger';
import { Spinner } from 'components/spinner';
import styles from './CarrelloFooterContainer.module.scss';
import { tipoCarrelloSelected, toggleCarrello } from '../carrelloSlice';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useInternalSession } from 'hooks';
import useWindowSize from 'hooks/useWindowSize';

export type CarrelloFooterContainerProps = {
  errors?: BannerInformationPropsType[];
  children?: React.ReactNode;
  labelBtnDx?: string;
  labelBtnSx?: string;
  type: MovimentiTipoScommessaEnum;
};

// eslint-disable-next-line react/display-name
export const CarrelloFooterContainer = forwardRef<HTMLDivElement, CarrelloFooterContainerProps>(
  ({ errors, children, labelBtnDx, labelBtnSx, type }, forwardedRef) => {
    const dispatch = useAppDispatch();
    const { isAuthenticated } = useInternalSession();
    const { isMobile } = useWindowSize();

    const isFullCart = useTypedSelector(selectIsFullCart);
    const isLoadingVendita = useTypedSelector(selectIsLoadingVendita);
    const esiti = useTypedSelector((state) => selectEsitiByTicket(state, type));
    const isCustomMobileInputOpened = useTypedSelector(selectIsCustomMobileOpened);

    const labelEspandi = useGetLabelByKey('espandi');
    const labelNascondi = useGetLabelByKey('nascondi');

    const ref = useRef<HTMLInputElement>(null);
    useImperativeHandle(forwardedRef, () => ref.current as HTMLDivElement);

    const handleClickEspandi = () => {
      dispatch(toggleCarrello({ isFullCart: true, isOpen: true }));
      dispatch(tipoCarrelloSelected(type));
    };

    return (
      <div className={styles.container} ref={ref} data-carrello-footer-type={type}>
        <div className={styles.errorWrapper}>
          {errors &&
            Object.keys(esiti).length > 0 &&
            errors.map((error: BannerInformationPropsType, index) => {
              return <BannerInformation key={`${error.text}_${index}`} {...error} />;
            })}
        </div>
        {!isFullCart && (
          <div className={styles.actionContainer}>
            <button className={styles.button} onClick={() => dispatch(toggleCarrello({ isOpen: false }))}>
              {labelBtnSx ? labelBtnSx : labelNascondi}
            </button>
            <button className={styles.button} onClick={handleClickEspandi}>
              {labelBtnDx ? labelBtnDx : labelEspandi}
            </button>
          </div>
        )}
        {children}
        {isCustomMobileInputOpened && <CustomMobileInput />}
        {!isMobile && isFullCart && isAuthenticated && <CarrelloBonusButtons hasPadding />}

        {isLoadingVendita && (
          <div className={styles.spinnerContainer}>
            <Spinner className={styles.spinner} />
          </div>
        )}
      </div>
    );
  }
);
